import ApiService from '@/core/services/api.service';

export default {
  /**
   * Fetch employees for approval config
   *
   * @returns {Promise} - Promise with the employee data
   */
  async fetchListFilter() {
    try {
      const response = await ApiService.get('/v1/employees/get-list-filter');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching employees:', error);
      throw error;
    }
  },
};
